import { APIPromise, easasJsVersionsSrvAxios } from "services/HttpService";
import { ApiDefinition } from "./ApiDefinition";

class EasasJsVersionsApiDefinition extends ApiDefinition {
  constructor() {
    super("", easasJsVersionsSrvAxios);
  }

  async getBuilds(): APIPromise<EasasJsBuildsResponse> {
    return this.get(`builds`);
  }
}

type EasasJsBuildsResponse = {
  builds: Array<string>;
};

export const EasasJsVersionsApi = new EasasJsVersionsApiDefinition();
